"use strict";
/**
 * Schema-level normalization: drops transient editor markers (`__clientId`),
 * clamps user strings, rejects non-http(s) URLs, and strips reserved record
 * keys. Used both before persisting and as the canonical form for change
 * detection (so two structurally-equivalent schemas compare equal even if
 * they differ in object-key insertion order).
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sanitizeAiHubSettingsSchema = void 0;
var ai_hub_settings_safe_records_1 = require("./ai-hub-settings-safe-records");
var sanitizeSystem = function (system) {
    var next = {
        id: ai_hub_settings_safe_records_1.clampUserString(system.id),
        name: ai_hub_settings_safe_records_1.clampUserString(system.name),
        type: ai_hub_settings_safe_records_1.clampUserString(system.type),
        sync: ai_hub_settings_safe_records_1.clampUserString(system.sync),
        config: ai_hub_settings_safe_records_1.sanitizeRecord(system.config),
    };
    var baseUrl = ai_hub_settings_safe_records_1.sanitizeHttpUrl(system.baseUrl);
    if (baseUrl) {
        next.baseUrl = baseUrl;
    }
    var url = ai_hub_settings_safe_records_1.sanitizeHttpUrl(system.url);
    if (url) {
        next.url = url;
    }
    // `__clientId` is intentionally not copied — transient editor marker.
    return next;
};
var sanitizeStringList = function (values) {
    return (values || []).map(function (entry) { return ai_hub_settings_safe_records_1.clampUserString(entry); }).filter(function (entry) { return !!entry; });
};
var sanitizeWorkflow = function (workflow) {
    var next = {
        id: ai_hub_settings_safe_records_1.clampUserString(workflow.id),
        name: ai_hub_settings_safe_records_1.clampUserString(workflow.name),
        sources: sanitizeStringList(workflow.sources),
        targets: sanitizeStringList(workflow.targets),
    };
    var otherSystems = ai_hub_settings_safe_records_1.sanitizeRecord(workflow.otherSystems);
    if (Object.keys(otherSystems).length > 0) {
        next.otherSystems = otherSystems;
    }
    var config = ai_hub_settings_safe_records_1.sanitizeRecord(workflow.config);
    if (Object.keys(config).length > 0) {
        next.config = config;
    }
    return next;
};
var sanitizeMapping = function (mapping) {
    var next = {
        system: ai_hub_settings_safe_records_1.clampUserString(mapping.system),
        field: ai_hub_settings_safe_records_1.clampUserString(mapping.field),
    };
    if (mapping.defaultValue) {
        next.defaultValue = ai_hub_settings_safe_records_1.clampUserString(mapping.defaultValue);
    }
    var normalizedMap = ai_hub_settings_safe_records_1.sanitizeRecord(mapping.map);
    if (Object.keys(normalizedMap).length > 0) {
        next.map = normalizedMap;
    }
    if (mapping.valueSet && (mapping.valueSet.append || mapping.valueSet.format)) {
        next.valueSet = {
            append: !!mapping.valueSet.append,
            format: ai_hub_settings_safe_records_1.clampUserString(mapping.valueSet.format),
        };
    }
    if (mapping.config) {
        var config = __assign(__assign({}, (mapping.config.userNameSubField
            ? { userNameSubField: ai_hub_settings_safe_records_1.clampUserString(mapping.config.userNameSubField) }
            : {})), (mapping.config.emailAddressSubField
            ? { emailAddressSubField: ai_hub_settings_safe_records_1.clampUserString(mapping.config.emailAddressSubField) }
            : {}));
        if (Object.keys(config).length > 0) {
            next.config = config;
        }
    }
    return next;
};
var sanitizeField = function (field) {
    var next = {
        name: ai_hub_settings_safe_records_1.clampUserString(field.name),
        mapping: (field.mapping || []).map(sanitizeMapping),
    };
    if (field.ignore) {
        next.ignore = true;
    }
    return next;
};
/**
 * Remove transient empty values, strip `__clientId` editor markers, clamp
 * user string lengths, and reject non-http(s) URL schemes before comparing
 * or submitting.
 */
exports.sanitizeAiHubSettingsSchema = function (config) { return ({
    systems: (config.systems || []).map(sanitizeSystem),
    workflows: (config.workflows || []).map(sanitizeWorkflow),
    fields: (config.fields || []).map(sanitizeField),
}); };
